
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_33355_178937)"}},[_c('path',{attrs:{"d":"M13.344 2c.74 0 1.387.403 1.731 1h1.769a1.5 1.5 0 011.5 1.5v10a1.5 1.5 0 01-1.5 1.5h-4.5V7.5a2.5 2.5 0 00-2.5-2.5h-1.5v-.5a1.5 1.5 0 011.5-1.5h1.769c.343-.597.99-1 1.73-1zm-3.5 4a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5h-6a1.5 1.5 0 01-1.5-1.5V10h3c.553 0 1-.447 1-1V6h3.5zm3.5-2.75a.75.75 0 100 1.5.75.75 0 000-1.5zm-8 2.75v3h-3l3-3z","fill":"#999"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_33355_178937"}},[_c('path',{attrs:{"fill":"#fff","transform":"matrix(-1 0 0 1 18.344 2)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    